export default {
  extensiveEntryTypes: ["navigation", "paint", "longtask", "resource"],
  defaultEntryTypes: ["navigation", "paint", "longtask"],
  defaultMetrics: [
    "requestTime",
    "responseTime",
    "totalRequestResponseTime",
    "perceivedPageLoadTime",
  ],
};
